import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Donate",
  tags: ["#page", "#inline"],
}

export default defineBlock("support/donate", (props) => {
  return (
    <div className="donate content-sized block-spacing flex items-center justify-center">
      <div className="w-full md:w-narrowContentW bg-blue text-white">
        <InnerBlocks
          allowedBlocks={["support/donate-left", "support/donate-right"]}
          template={[
            ["support/donate-left", {}],
            ["support/donate-right", {}],
          ]}
          className="w-full grid gap-9 grid-cols-1 md:grid-cols-2"
          templateLock="all"
        />
      </div>
    </div>
  )
})
